import { render, staticRenderFns } from "./SpaceConfigurationResourceMapping.vue?vue&type=template&id=684fef42&"
import script from "./SpaceConfigurationResourceMapping.vue?vue&type=script&lang=js&"
export * from "./SpaceConfigurationResourceMapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports